module.exports = __webpack_public_path__ + "img/empreendedor-rural.6798d9c1.jpg";